import { createApiHandler } from './handler';

const franchises = {
  apiClient: null,
  path: '/admin/franchises',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

};

export default franchises;
